function SectionFaqJobs() {
    return (
        <>
            <div className="tw-faq-section">
                <div className="accordion tw-faq" id="sf-faq-accordion-2">
                    {/*one*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ1-2" aria-expanded="false">
                            How do I redeem a coupon?
                        </button>
                        <div id="FAQ1-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*two*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ2-2" aria-expanded="false">
                            How long will it take to post my job?
                        </button>
                        <div id="FAQ2-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*three*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ3-2" aria-expanded="false">
                            What is your cancellation policy?
                        </button>
                        <div id="FAQ3-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*four*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ4-2" aria-expanded="false">
                            Where Can I Find Market Research Reports?
                        </button>
                        <div id="FAQ4-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*five*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ5-2" aria-expanded="false">
                            Do I need to know PHP to use TheJobs?
                        </button>
                        <div id="FAQ5-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                    {/*six*/}
                    <div className="accordion-item">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#FAQ6-2" aria-expanded="false">
                            How soon will I start receiving resumes?
                        </button>
                        <div id="FAQ6-2" className="accordion-collapse collapse" data-bs-parent="#sf-faq-accordion-2">
                            <div className="accordion-body">
                                A digital interface the person causing the movement of goods uploads the relevant information prior to the commencement of movement of goods and generates e-way bill on the GST portal. Best service are provide us. simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionFaqJobs;